import createReducer from "./../createReducer";
import { ISelectedState } from "./types";
import { handlersSelected } from "./handlers";

export const selectedInitialState: ISelectedState = {
    isSelectedBackground: false,
    isLabelSeleced: null,
    isInputSeleced: null,
    isInputValueSeleced: null,
    isChoicesSelected: null,

    item: null,
    items: [],
};

export default createReducer(selectedInitialState, handlersSelected);
